import { JsonObject, JsonProperty } from "ta-json";

@JsonObject()
export class SearchGroupRequestResource {
    @JsonProperty("row")
    row?: string;

    @JsonProperty("column")
    column?: string;

    @JsonProperty("result_count")
    resultCount?: number;

    @JsonProperty("asc")
    ascending: boolean = true;

    @JsonProperty("skip")
    skip: number = 0;

    @JsonProperty("take")
    take: number = 20;

    constructor(init?: Partial<SearchGroupRequestResource>) {
        Object.assign(this, init);
    }
}
